export default __webpack_public_path__ + "static/media/mail.8fbfe65e.svg";